import React from 'react';
import styled from 'styled-components/macro';

const ContentsLayoutWrapper = styled.div`
    /* min-height: 100vh; */
    min-width: 100%;
    background-color: #f6fbfb;
`;

const ContentsLayout = ({ children }) => (
    <ContentsLayoutWrapper>
        {children}
    </ContentsLayoutWrapper>
);

export default ContentsLayout;